export default __webpack_public_path__ + "static/media/university.ef65e931.svg";